{
  "title": "Slot Requests",
  "description": "Review customer time requests and open slots when you can accommodate them",
  "searchPlaceholder": "Search slot requests...",
  "emptyTitle": "No slot requests",
  "emptyDescription": "When customers request unavailable times, their requests will appear here.",
  "approve": "Approve",
  "decline": "Decline",
  "columns": {
    "customer": "Customer",
    "service": "Service",
    "provider": "Provider",
    "date": "Date",
    "time": "Time",
    "status": "Status",
    "created": "Created"
  },
  "dialog": {
    "approveTitle": "Approve time request",
    "rejectTitle": "Decline time request",
    "description": "{{customer}} requested {{date}} at {{time}} for {{service}}.",
    "customerFallback": "Customer",
    "serviceFallback": "a service",
    "oneOffTitle": "One-off (this date only)",
    "oneOffDescription": "Opens the slot only for the requested calendar date.",
    "recurringTitle": "Recurring (every week)",
    "recurringDescription": "Adds this time to the provider's weekly schedule.",
    "rejectReasonLabel": "Reason (optional)",
    "rejectReasonPlaceholder": "Let the customer know why this time isn't available",
    "customerNote": "Customer note: {{note}}",
    "approveSuccess": "Slot opened — customer will be notified to book",
    "rejectSuccess": "Request declined",
    "actionFailed": "Action failed",
    "approveConfirm": "Approve & open slot",
    "rejectConfirm": "Decline request"
  }
}
